import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../../components/ui/table';

export const markdownTableComponents = {
  table: ({ node, ...props }) => <Table {...props} />,
  thead: ({ node, ...props }) => <TableHeader {...props} />,
  tbody: ({ node, ...props }) => <TableBody {...props} />,
  tr: ({ node, ...props }) => <TableRow {...props} />,
  th: ({ node, ...props }) => <TableHead {...props} />,
  td: ({ node, ...props }) => <TableCell {...props} />,
};

// Typography (paragraphs, lists, inline code, links, headings) lives in
// chat.css under .q-md so every markdown surface in the chat reads the same.
const components = markdownTableComponents;

const TextBubble = ({ blockData = {} }) => {
  const text = typeof blockData === 'string' ? blockData : (blockData.text || '');
  if (!text) return null;
  return (
    <div className="q-md">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{text}</ReactMarkdown>
    </div>
  );
};

export default TextBubble;
